/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Const

import { cloneDeep, isEmpty } from 'lodash';

const __vue_script__ = {
    name: 'DocumentAttachments',

    props: {
        eventId: {
            type: String,
            required: true
        },

        document: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            lastRev: this.document._rev,
            attachments: []
        };
    },

    watch: {
        document: {
            immediate: true,
            handler() {
                this.attachments = [];
                this.formatAttachments();
            }
        }
    },

    methods: {
        /**
         * Formats the attachments of a given document
         */
        formatAttachments() {
            const document = this.document;
            const attachments = document._attachments || document.fp_attachments_s3;
            if (!attachments) {
                return;
            }

            this.attachments = Object.keys(attachments).map(key => {
                const att = attachments[key];
                return {
                    name: key,
                    contentType: att.content_type,
                    size: this.$utils.numbers.humanFileSize(att.length),
                    url: this.getDownloadUrl(key),
                    deletable: document.hasOwnProperty('_attachments') && document._rev === this.lastRev
                };
            });
        },

        getDownloadUrl(attachment) {
            const doc = this.document;
            if (doc.filePath) {
                return doc.filePath;
            }

            return this.$utils.assets.getEventAttachmentPath(this.eventId, attachment, doc._id);
        },

        isImage(contentType) {
            return (contentType || '').startsWith('image/');
        },

        deleteAttachment(att) {
            this.$modal.show('dialog', {
                text: this.$t('dev_tools.document_editor.attachments.delete_prompt', [att.name]),
                buttons: [
                    {
                        title: this.$t('general.cancel'),
                        default: true,
                        class: 'btn'
                    },
                    {
                        title: this.$t('dev_tools.document_editor.attachments.delete'),
                        handler: async () => {
                            const doc = cloneDeep(this.document);
                            delete doc._attachments[att.name];

                            if (isEmpty(doc._attachments)) {
                                delete doc._attachments;
                            }

                            this.$emit('save', doc);
                            this.$modal.hide('dialog');
                        },
                        class: 'btn btn-danger'
                    }
                ]
            });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.attachments.length)?_c('div',{staticClass:"document-attachments"},[_c('h4',[_vm._v(_vm._s(_vm.$t('dev_tools.document_editor.attachments.title', [_vm.attachments.length])))]),_vm._l((_vm.attachments),function(att){return _c('a',{key:att.name,staticClass:"attachment",attrs:{"href":att.url,"target":"_blank","rel":"noopener noreferrer"}},[_c('div',{staticClass:"media"},[(_vm.isImage(att.contentType))?_c('img',{attrs:{"src":att.url,"alt":att.name}}):_c('i',{staticClass:"ic-file"})]),_c('div',{staticClass:"details"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(att.name))]),_c('div',{staticClass:"ext"},[_vm._v(_vm._s(att.contentType)+" • "+_vm._s(att.size))])]),_c('div',{staticClass:"actions"},[(att.deletable)?_c('button',{staticClass:"btn btn-icon btn-danger single",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.deleteAttachment(att)}}},[_c('i',{staticClass:"ic-trash-2"})]):_vm._e()])])})],2):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "DocumentAttachments.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__